import React from 'react';

// components
import CommonSidebar from "../Common/CommonSidebar";
import LeadCreateModal from "../Lead/LeadCreateModal";
import retrievePermission from "../../utils/retrievePermission";

//icons
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import ApprovalIcon from "@mui/icons-material/Approval";
import GavelIcon from '@mui/icons-material/Gavel';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import SummarizeIcon from "@mui/icons-material/Summarize";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';


class OpportunitySidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            payCertPermission: 0,
            opportunityEvaluationPermission: 0
        };
    }

    async componentDidMount() {
        await this.retrievePayCertPermission();
        await this.retrieveOpportunityEvaluationPermission();
    }

    async retrieveOpportunityEvaluationPermission(){
        let p = await retrievePermission(
            'OpportunityViewSet',
            'evaluation',
            this.context.subscriberObject
        );
         this.setState(
            {
                opportunityEvaluationPermission: p,
            }
         )
    }

    async retrievePayCertPermission(){
        let p = await retrievePermission(
            'OppPaymentViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        p *= await retrievePermission(
            'OppCertViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                payCertPermission: p,
            }
        )
    }

    render() {
        return(
            <CommonSidebar
                groups={
                    [
                        {
                            title: 'Лиды',
                            items: [
                                {
                                    type: 'component',
                                    component: <LeadCreateModal />
                                },
                                {
                                    title: 'Нераспределенные',
                                    link: '/lead/waiting/',
                                    icon: QuestionMarkIcon,
                                },
                                {
                                    title: 'Входящие',
                                    link: '/lead/incoming/',
                                    icon: MoveToInboxIcon,
                                },
                                {
                                    title: 'Исходящие ',
                                    link: '/lead/outgoing/',
                                    icon: ForwardToInboxIcon,
                                }
                            ],
                        },
                        {
                            title: 'Сделки',
                            items: [
                                {
                                    title: 'Отчет',
                                    link: '/opportunity/report/',
                                    icon: LocalOfferIcon,
                                },
                                {
                                    title: 'Центр',
                                    link: '/opportunity/comments/',
                                    icon: SelfImprovementIcon,
                                },
                                {
                                    title: 'Анализ',
                                    link: '/opportunity/evaluation/',
                                    icon: AnalyticsIcon,
                                    hide: !this.state.opportunityEvaluationPermission,
                                }
                            ],
                        },
                        {
                            title: 'Срезы',
                            items: [
                                {
                                    title: 'Активные',
                                    link: '/slice/open/',
                                    icon: SummarizeIcon,
                                },
                                {
                                    title: 'Завершенные',
                                    link: '/slice/completed/',
                                    icon: FactCheckIcon,
                                },
                            ],
                        },
                        {
                            title: 'Договорные документы',
                            hide: !this.state.payCertPermission,
                            items: [
                                {
                                    title: 'ТКП',
                                    link: '/quote/',
                                    icon: AccountBalanceWalletIcon,
                                },
                                {
                                    title: 'Договоры',
                                    link: '/contract/contract/',
                                    icon: GavelIcon,
                                },
                                {
                                    title: 'Входящие платежи',
                                    link: '/contract/payment/',
                                    icon: CurrencyRubleIcon,
                                },
                                {
                                    title: 'Акты',
                                    link: '/contract/certificate/',
                                    icon: ApprovalIcon,
                                },
                            ],
                        },
                    ]
                }
            />
        )
    }
}

export default OpportunitySidebar
